export default __webpack_public_path__ + "static/media/Giftcards_round_icon.c71c12ac.svg";